"use strict";
// Contact model for address book functionality
// All models must include ownerId for SaaS multi-tenancy
Object.defineProperty(exports, "__esModule", { value: true });
